"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExistingPayment = void 0;
const classnames_1 = __importDefault(require("classnames"));
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const dateTimeFormat_1 = require("../../../../utils/dateTimeFormat");
const getPaymentIcon_1 = require("../../../../utils/getPaymentIcon");
const Icon_1 = require("../../../Icon");
require("./index.scss");
const ExistingPayment = (props) => {
    const { className, amount, code, date } = props;
    const classNames = (0, classnames_1.default)('admin-payment-existing-payment', className !== null && className !== void 0 ? className : '');
    const datetime = (0, moment_1.default)(date, dateTimeFormat_1.DATETIME_OUTPUT_FORMAT).format(dateTimeFormat_1.DATETIME_FORMAT);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("span", { className: 'admin-payment-existing-payment__amount' },
            amount,
            " CHF"),
        react_1.default.createElement("span", { className: 'admin-payment-existing-payment__icon' },
            react_1.default.createElement(Icon_1.Icon, { name: (0, getPaymentIcon_1.getPaymentIcon)(code) })),
        react_1.default.createElement("span", { className: 'admin-payment-existing-payment__date' }, datetime)));
};
exports.ExistingPayment = ExistingPayment;
//# sourceMappingURL=ExistingPayment.js.map